var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tool-list-about-card" }, [
    _c(
      "span",
      {
        class: { active: _vm.gridStyle === "block" },
        on: {
          click: function ($event) {
            return _vm.changeStyle("block")
          },
        },
      },
      [_c("eva-icon", { attrs: { fill: "#000", name: "grid-outline" } })],
      1
    ),
    _c(
      "span",
      {
        class: { active: _vm.gridStyle === "list" },
        on: {
          click: function ($event) {
            return _vm.changeStyle("list")
          },
        },
      },
      [_c("eva-icon", { attrs: { fill: "#000", name: "list-outline" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }